import "../less/layout.less";

import $ from "jquery";
import ShowPhoneAfterClick from "./binding/showPhoneAfterClick";
import Tooltip from "./binding/tooltip";
import Numeric from "./binding/numeric";
import CompaniesSlider from "./binding/companiesSlider";

import "blueimp-gallery/js/jquery.blueimp-gallery";

import "bootstrap/js/dropdown";
import "bootstrap/js/modal";
import "bootstrap-hover-dropdown";

import svg4everybody from "svg4everybody";
svg4everybody();

import LazyLoad from "vanilla-lazyload";
$(document).ready(function () {
    new LazyLoad({
        elements_selector: ".lazy"
    });
});

ShowPhoneAfterClick.apply($(document.body));
Tooltip.apply($(document.body));
Numeric.apply($(document.body));
CompaniesSlider.apply($(document.body));
